import { bool, object } from "prop-types";
import { observer } from "mobx-react";
import {
  ValueCell,
  useEstimateStructure,
  useEstimateTableSettings,
  usePresetFieldNames,
  useEstimateEditorSettings
} from "@tools";

export const TaskMaterialsCell = observer(() => {
  const { displayTwoValues } = useEstimateStructure();
  const { isProposal } = useEstimateEditorSettings();
  const { totalEstimateCells, showCombinedHours, materialsSection } = useEstimateTableSettings();
  const { getFieldName } = usePresetFieldNames(isProposal);
  
  if(!showCombinedHours)
    return <>
      <ValueCell
        isHeader
        size={displayTwoValues ? "medium" : "small"}
      >
        <span className="preset-tableBreakdownHeader pt-unitPrice">
          {getFieldName("pt-unitPrice")}
        </span>
      </ValueCell>
      <ValueCell
        isHeader
        size={displayTwoValues ? "medium" : "small"}
      >
        <span className="preset-tableBreakdownHeader pt-units">
          {getFieldName("pt-units")}
        </span>
      </ValueCell>
    </>
  
  if(showCombinedHours && !materialsSection && totalEstimateCells > 0)
    return <ValueCell size={displayTwoValues ? "large" : "medium"} />
})

TaskMaterialsCell.propTypes = {
  section: object.isRequired,
  extendPadding: bool,
}